// Import necessary React Router hooks
import { useNavigate } from "react-router-dom";
// Import necessary Material-UI components
import MenuItem from "@mui/material/MenuItem";
import Grid from "@mui/material/Grid";
import CssBaseline from "@mui/material/CssBaseline";
// Import custom hooks
import { useAuthInfo, logoutUser } from "../common";
import { handleMenuItemClick } from "./handleMenuItemClick.function";

// Define the style for menu items
const menuItemStyle = {
  borderRadius: "5px",
  fontSize: "12px",
  fontWeight: "400",
  "&:hover": {
    border: "1px solid",
  },
};

export function TopAppBarMenu({ menuItems }) {
  // Access the decoded authentication information
  const decoded = useAuthInfo();
  // Hook to navigate programmatically
  const history = useNavigate();

  return (
    <div>
      <CssBaseline />
      <Grid
        container
        direction="row"
        justifyContent="flex-end"
        alignItems="center"
        sx={{
          color: "#9F8656",
          display: { xs: "none", md: "none", lg: "flex" },
        }}
      >
        {/*  Map over the menuItems prop to render each menu item */}
        {menuItems.map((item) =>
          item.access.map(
            (access, index) =>
              access === decoded.role && (
                <MenuItem
                  key={index}
                  sx={menuItemStyle}
                  onClick={() => handleMenuItemClick(item, history)}
                >
                  {item.title}
                </MenuItem>
              ),
          ),
        )}
        {/*  Render a logout menu item */}
        <MenuItem sx={menuItemStyle} onClick={() => logoutUser(history)}>
          Log Out
        </MenuItem>
      </Grid>
    </div>
  );
}
